import React, { useRef, useState } from "react"

import ContentfulNavigation from "components/page-components/navigation"
import useProgress from "../hooks/useProgress"

import ProgressBar from "./progress-bar"
import TopAd from "../ads/top-ad"
import { TopAdContainer } from "./styles"

const Navigation = ({ article, bodyBackground, isTranslucent }) => {
  const { category, template } = article
  const variant = category.toLowerCase()
  const isPremium = template === "premium"

  const progressRef = useRef(0)
  const [hideNavigation, setHideNavigation] = useState(false)

  useProgress((currentProgress) => {
    if (!isPremium) {
      const isScrollingDown = currentProgress !== 0 && progressRef.current <= currentProgress
      setHideNavigation(isScrollingDown)

      progressRef.current = currentProgress
    }
  })

  return (
    <ContentfulNavigation
      id="article-navigation"
      variant={variant}
      beforeNavElement={
        <TopAdContainer id="article-top-ad" background={bodyBackground}>
          <TopAd article={article} />
        </TopAdContainer>
      }
      subNavElement={isTranslucent ? null : <ProgressBar hide />}
      hideMainNav={hideNavigation}
      isTranslucent={isTranslucent}
    />
  )
}

export default Navigation
